import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Popover, FormGroup, Divider, TextField, makeStyles } from '@material-ui/core';
import { ArrowDropDown } from '@material-ui/icons';

import { ChipFilterWrapper } from 'src/components/filter/ChipFilterWrapper';
import { AutocompleteWrapper } from 'src/components';


const useStyles = makeStyles(() => ({
  popoverTextField: {
    minWidth: 250,
  },
  menuOptionsPopper: {
    width: `250px !important`,
  },
  chip: {
    backgroundColor: 'transparent',
  },
}));

const FilterYearComparison = ({ id, prevValue, onChange, options, inline = false, cleanable = false }) => {

  const classes = useStyles();

  const [ anchorEl, setAnchorEl ] = useState(null);
  const isOpenPopover = Boolean(anchorEl);
  const popoverId = isOpenPopover ? 'simple-popover' : undefined;

  const openPopup = event => setAnchorEl(event.currentTarget);

  const closePopup = () => setAnchorEl(null);

  const [ year, setYear ] = useState(prevValue[0]);
  const [ comparisonYear, setComparisonYear ] = useState(prevValue[1]);

  useEffect(() => {
    setYear(prevValue[0]);
    setComparisonYear(prevValue[1]);
  }, [ prevValue ]);

  const handleConfirm = () => {
    // TODO: implementar modo inline (cuando sea necesario)
    if (inline) {
      throw new Error('Inline mode is not implemented for FilterYearComparison');
    } else {
      onChange([ year, comparisonYear ]);
      closePopup();
    }
  };

  const handleDelete = () => {
    onChange({ id, value: false });
  };

  return (
    <>
      {inline ?
        <>
          Falta implementar modo sin popover
        </>
        :
        <>
          <Popover
            id={popoverId}
            open={isOpenPopover}
            anchorEl={anchorEl}
            onClose={closePopup}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          >
            <Box px={2} pt={2} pb={1}>
              <FormGroup>
                <AutocompleteWrapper
                  options={options}
                  getOptionLabel={option => option.toString()}
                  onChange={(_, newValue) => setYear(newValue)}
                  getOptionSelected={(option, [ value ]) => option === value}
                  value={[ year ]}
                  renderInput={params => (
                    <TextField {...params} autoFocus variant="outlined" label="Año" color="secondary"
                      InputProps={{ ...params.InputProps, className: classes.popoverTextField }}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
                <br />
                <AutocompleteWrapper
                  options={options}
                  getOptionLabel={option => option.toString()}
                  onChange={(_, newValue) => setComparisonYear(newValue)}
                  getOptionSelected={(option, [ value ]) => option === value}
                  value={[ comparisonYear ]}
                  renderInput={params => (
                    <TextField {...params} variant="outlined" label="Año a comparar" color="secondary"
                      InputProps={{ ...params.InputProps, className: classes.popoverTextField }}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                />
                <Box mt={4}>
                  <Divider />
                </Box>
                <Box mt={1} display="flex" alignSelf="flex-end">
                  <Button color="default" size="small" onClick={handleConfirm}>Aplicar</Button>
                </Box>
              </FormGroup>
            </Box>
          </Popover>
          <ChipFilterWrapper
            isActive={true}
            isFocused={isOpenPopover}
            icon={<ArrowDropDown fontSize="small" />}
            label={`${prevValue[0]} vs ${prevValue[1]}`}
            onClick={openPopup}
            className={classes.chip}
            {...((prevValue && cleanable) ? { onDelete: handleDelete } : {})}
          />
        </>
      }
    </>
  );
};

FilterYearComparison.propTypes = {
  id: PropTypes.string.isRequired,
  prevValue: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  inline: PropTypes.bool,
  options: PropTypes.array.isRequired,
  cleanable: PropTypes.bool,
};


export {
  FilterYearComparison,
};